module.exports = __webpack_public_path__ + "static/media/office2.3da523c1.jpg";